import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconHome = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconHome.dimensions.width} ${IconHome.dimensions.height}`}
      {...otherProps}
    >
      <Path
        fill={color || Color.premiumBlack}
        d="M17.715 8.451c-2.758-2.593-5.531-5.15-8.297-7.736-.308-.287-.537-.287-.845 0L5.155 3.898v-1.34H4.43c-.738 0-1.44-.015-2.15.014-.422.015-.673.295-.666.825v3.809c-.43.405-.86.803-1.29 1.208-.186.177-.386.685-.307.825.272.465.558.067.802-.154l.86-.796c0 3.087-.014 6.122.014 9.158 0 .582.358 1.024.874 1.03 1.605.03 3.217.016 4.901.016v-5.356h3.174V18.5h4.428c1.032 0 1.333-.361 1.333-1.591V8.635c0-.088 0-.184-.007-.272.28.258.552.515.831.773.236.221.516.538.752.103.08-.147-.093-.618-.265-.78V8.45ZM2.375 3.45H4.43v1.127c-.673.626-1.354 1.26-2.027 1.893-.022-.972-.03-2.446-.03-3.02Zm13.27 5.835c0 2.526.007 5.06-.015 7.588 0 .236-.179.678-.286.678-1.304.044-2.601.03-3.963.03v-4.2c0-1.069-.122-1.209-1.06-1.216H7.67c-.817 0-.967.184-.967 1.164v4.259c-1.269 0-2.43-.03-3.59.014-.545.022-.695-.206-.695-.825.021-2.682.007-5.363.007-8.045v-1.15c.373-.346.745-.692 1.125-1.038 1.806-1.672 3.611-3.352 5.431-5.04.222.192.408.354.595.524 2.02 1.871 4.04 3.75 6.061 5.628v1.629h.008Z"
      />
    </Svg>
  )
}

IconHome.dimensions = {
  width: 18,
  height: 19,
}

export default IconHome
